module.exports = __webpack_public_path__ + "media/application/images/svgs/map-pin-3e507576ae1673924bde6bc8d7b07e47.svg";